import { render, staticRenderFns } from "./SupplyMonitor.vue?vue&type=template&id=155f3fac&scoped=true"
import script from "./SupplyMonitor.vue?vue&type=script&lang=js"
export * from "./SupplyMonitor.vue?vue&type=script&lang=js"
import style0 from "./SupplyMonitor.vue?vue&type=style&index=0&id=155f3fac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155f3fac",
  null
  
)

export default component.exports